export const sortItems = <Item, Key extends keyof Item>(
  items: Item[],
  order: Item[Key][],
  key: Key,
): Item[] => {
  const orderMap = order.reduce<Record<string, number>>((acc, value, index) => {
    acc[value as string] = index;
    return acc;
  }, {});
  const orderedItems = items.filter((item) => order.includes(item[key]));
  const leftOverItems = items.filter((item) => !order.includes(item[key]));

  return [
    ...orderedItems.slice().sort((a, b) => {
      const aOrder = orderMap[a[key] as string];
      const bOrder = orderMap[b[key] as string];
      return aOrder - bOrder;
    }),
    ...leftOverItems,
  ];
};
